import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

export default {
  state: {
    alert: {
    	type: -1,
    	message: ''
    }
  },
  getters: {
    alert (state) {
      return state.alert
    }
  },
  mutations: {
    SET_ALERT (state, data) {
        state.alert = data

        setTimeout(()=>{
        	state.alert = {
    			type: -1,
    			message: ''
    		}
        }, 3000)
    }
  },
  actions: {
   
  },

}







